<template>
	<div class="flex-fill d-flex overflow-hidden">
		<div v-if="showLoader" class="loader1">
			<div>
				<div class="lds-ripple" >
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
		<transition name="collapse-width">
			<!-- <div v-show="showList" :class="{ 'd-flex flex-column': showList }" > -->
			<div class="forIpadUIConvo d-flex flex-column">
				<div id="ConvoList" class="bg-white border flex-fill d-flex flex-column overflow-hidden">
					<div class="p-3 border-bottom">
						<div class="d-flex">
						<div class="flex-fill position-relative">
							<b-input type="search" placeholder="Search Conversations..." v-model="search" debounce="500"/>
							<b-list-group class="text-center position-absolute w-100">
								<b-list-group-item
									class="py-2"
									:key="prosp.id"
									style="z-index: 1000"
									v-for="prosp in filteredProspects"
									button @click="openSearch(prosp)"
								>
									{{$parseAlias(prosp)}}
								</b-list-group-item>
							</b-list-group>
						</div>
						<b-dropdown variant="outline" right toggle-class="mr-1" >
							<template v-slot:button-content>
								<b class="filterHead">Filter</b>
							</template>
							<b-dropdown-group style="max-height: 22em; overflow-y: auto">
								<h6 class="text-center text-blue">Defaults</h6>
								<!-- <b-dropdown-item-button v-if="sort != 0" @click="filterClick(0)">Recent</b-dropdown-item-button> -->
								<b-dropdown-item-button v-if="sort != 1" @click="filterClick(1)">Oldest</b-dropdown-item-button>
								<!-- <b-dropdown-item-button v-if="sort != 2" @click="filterClick(2)">Unread ({{ unreadCount }})</b-dropdown-item-button> -->
								<!-- <b-dropdown-item-button v-if="sort != 3" @click="filterClick(3)">Due Task ({{ dueTaskCount }})</b-dropdown-item-button> -->
								<b-dropdown-item-button v-if="sort != 4" @click="sortByStarred(currentPage, limit)">Starred ({{ this.$store.state.firebase.starredCount }})</b-dropdown-item-button>
								<!-- <b-dropdown-item-button v-if="sort != 5" @click="filterClick(5)">Scheduled ({{ scheduledCount }})</b-dropdown-item-button> -->
								<b-dropdown-item-button v-if="sort != 6" @click="filterClick(6)">Autopilot Active ({{ this.$store.state.firebase.autoPilotCount }})</b-dropdown-item-button>
								<b-dropdown-item-button v-if="sort != 7" @click="filterClick(7)">Feedback Needed ({{ this.$store.state.firebase.feedbackCount }})</b-dropdown-item-button>
								<b-dropdown-item-button v-if="sort != 8" @click="filterClick(8)">Errored ({{ this.$store.state.firebase.erroredCount }})</b-dropdown-item-button>
								<hr>
								<!-- @click="sort = 5 + i" -->
								<div v-if="user.Folders">
									<h6 class="text-center text-blue">Folders</h6>
									<b-dropdown-item-button
										:key="i"
										@click="sortByFolder(i, currentPage, limit);"
										v-for="i in user.Folders.length"
									>
										<span v-if="sort != 5 + i">{{user.Folders[i - 1]}}</span>
									</b-dropdown-item-button>
									<hr>
								</div>
								<div v-if="user.Stages">
									<h6 class="text-center text-blue">Stages</h6>
									<b-dropdown-item-button
										:key="i + user.Folders.length"
										@click="sortByStage(i, currentPage, limit);"
										v-for="i in user.Stages.length"
									>
										<span v-if="sort != 5 + user.Folders.length + i">{{user.Stages[i - 1]}}</span>
									</b-dropdown-item-button>
									<b-dropdown-item-button @click="sort = -1" v-if="sort != -1">
										Archived
									</b-dropdown-item-button>
								</div>
								<hr>
								<div>
									<h6 class="text-center text-blue">Assessment</h6>
									<!-- <b-dropdown-item-button>Priority:0 </b-dropdown-item-button> -->
									<!-- <b-dropdown-item-button @click="sortByPriority(0)">Priority:0 </b-dropdown-item-button> -->
									<b-dropdown-item-button @click="sortByPriority(1,currentPage, limit)">Priority:1 </b-dropdown-item-button>
									<b-dropdown-item-button @click="sortByPriority(2,currentPage, limit)">Priority:2 </b-dropdown-item-button>
									<b-dropdown-item-button @click="sortByPriority(3,currentPage, limit)">Priority:3 </b-dropdown-item-button>
								</div>
							</b-dropdown-group>
						</b-dropdown>
						</div>
						<div class="d-relative d-flex badge-container flex-wrap">
							<b-badge pill variant="light" class="badge-item" :class="{ 'click-background': activeFilter === 1 }" @click="setActiveFilter(1);filterClick(0)" >Recent</b-badge>
							<b-badge pill variant="light" class="badge-item" :class="{ 'click-background': activeFilter === 2 }" @click="setActiveFilter(2);filterClick(2)">Unread ({{ this.$store.state.firebase.unreadCount }})</b-badge>
							<b-badge pill variant="light" class="badge-item" :class="{ 'click-background': activeFilter === 4 }" @click="setActiveFilter(4);filterClick(3)">Due task ({{ dueTaskCountTotal }})</b-badge>
							<b-badge pill variant="light" class="badge-item" :class="{ 'click-background': activeFilter === 3 }" @click="setActiveFilter(3);filterClick(5)">Scheduled ({{ this.$store.state.firebase.scheduledCount }})</b-badge>
						</div>
					</div>

					<div v-if="sort == 0 || sort == 1 || sort == 2 || sort == 3 || sort == 5 || sort == 6 || sort == 7 || sort == 8" ref="convoList" class="flex-fill overflow-auto position-relative yscrollbar LoadMoreConvoScroll" id="yscrollbarstyle-1">
						<!-- <h6>{{ sortedConvos }}</h6> -->
						<ConversationItem
							:active="activeConvo == convo.id"
							:key="convo.id"
							v-for="convo in sortedConvos"
							:filter="sort"
							:convo="convo"
							@open="openConvo"
						/>
						<h5 v-if="!sortedConvos.length" class="center text-black-50">No Conversations</h5>
					</div>
					<div v-if="sort == 4 || sort > 8" ref="convoList" v-on:scroll="OnScroll" class="flex-fill overflow-auto position-relative LoadMoreConvoScroll">
						<ConversationItem
							:active="activeConvo == convo.id"
							:key="convo.id || index"
							v-for="convo in filteredConvos"
							:filter="sort"
							:convo="convo"
							@open="openConvo"
							:isPriorityClicked="isPriorityClicked"
						/>
						<h5 v-if="!filteredConvos.length" class="center text-black-50">No Conversations</h5>
					</div>

					<b-pagination
						v-model="currentPage"
						:total-rows="Math.min(totalRows, 10000)"
						:per-page="limit"
						@change="onPageChange"
						aria-controls="conversation-list"
						class="mt-2"
						style="justify-content: center;"
					></b-pagination>

				</div>
			</div>
		</transition>
		<MessageLog id="MessageLog" v-if="this.extensionuuid == null" :tempConvo="tempConvo" :prospect="prosp" :convo="convo" @open="changePage" @showLoader="manageLoader"   @getCallDetails="getCallDetails"   @testAutoConvo="getAutoConvoData"/>
		<MessageLogcopy id="MessageLog" v-if="this.extensionuuid != null" :tempConvo="tempConvo" :prospect="prosp" :convo="convo" @open="changePage" @showLoader="manageLoader"   @getCallDetails="getCallDetails"   @testAutoConvo="getAutoConvoData"/>
		
		<div v-if="convo || prosp" v-show="page == 'prosp'" transition="collapse-width">
			<div  :class="{ 'd-flex flex-column': page == 'prosp' }">
				<div id="Prospect" class="bg-white border flex-fill d-flex flex-column overflowY-auto">
					<Prospect
						:prospect="prosp"
						:number="prosp ? prosp.Number : convo.ClientNumber"
						@open="changePage"
						@delete="deleteProsp"
						@showLoader="manageLoader"
					/>
				</div>
			</div>
		</div>
		<b-modal id="ProspectModal1" hide-footer v-if="isNewProsp">
			<template v-slot:modal-title>
				Create Prospect
			</template> 
			<b-form @submit.stop.prevent="createProspect">
				<b-form-group label-cols="5" label="First Name:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.First"
						required />
				</b-form-group>
				<b-form-group label-cols="5" label="Last Name:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.Last"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Email:" class="my-1">
					<b-form-input
						type="email"
						v-model="form.Email"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Phone number:" class="my-1">
					<b-form-input
						type="tel"
						placeholder="(xxx) xxx-xxxx"
						v-mask="'(###) ###-####'"
						v-model="form.Number"
						/>
				</b-form-group>
				<b-form-group label-cols="5" label="Postal Code:" class="my-1">
					<b-form-input
						type="text"
						@keydown="isCheckPostalCode($event)"
						v-model="form.Zip"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Status:" class="my-1">
					<b-form-select
						:options="user.Stages"
						v-model="form.Status"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Tags:" class="my-1">
					<b-form-checkbox-group v-model="form.Tags">
						<b-form-checkbox :value="user.Folders[i-1]" :key="i" v-for="i in user.Folders.length">
							{{user.Folders[i-1]}}
						</b-form-checkbox>
					</b-form-checkbox-group>
				</b-form-group>
				<b-form-group label-cols="5" label="Notes:" class="my-1">
					<b-form-input
						type="text"
						v-model="NoteValue"/>
				</b-form-group>
				<b-form-checkbox
					v-model="optIn"
					class="my-3"
					required>
						<small>This prospect has given me permission to contact them via text message</small>
				</b-form-checkbox>
				<b-button type="submit" block variant="outline-primary">Save Prospect</b-button>
			</b-form> 
		</b-modal> 
	</div>
</template>

<script>
	import ConversationItem from './subcomponents/ConversationItem'
	import MessageLogcopy from './subcomponents/MessageLogcopy'
	import MessageLog from './subcomponents/MessageLog'
	import Prospect from './subcomponents/Prospect'
	import { mapState } from 'vuex'
	import { db,getPhoneData } from 'src/db.js'

	export default {
		name: "Conversations",
		components: {
			ConversationItem,
			MessageLogcopy,
			MessageLog,
			Prospect
		},
		computed: {
			convo() {
				if (!this.activeConvo) {
					return null;
				}
				return this.convos.find(convo => convo.id == this.activeConvo);
			},
			prosp() {
				if (!this.activeProsp) {
					return null;
				}
				return this.prospects.find(prosp => prosp.id == this.activeProsp);
			},
			showList() {
				return this.page == 'list' ||
					(this.page == 'convo' && this.format == 'big');
			},
			filteredProspects() {
				if (!this.search) {
					return [];
				}
				let prospMatches = this.prospects.filter(prosp => {
					let ret = false;
					if (prosp.Number) {
						ret = prosp.Number.includes(this.search) ||
								this.$parseNumber(prosp.Number).includes(this.search);
					}
					return ret || this.$parseAlias(prosp).toLowerCase().includes(this.search.toLowerCase());
				});
				if (prospMatches.length == 0) {
					return [{First: 'No', Last: 'Matches'}];
				}
				return prospMatches.slice(0, 8);
			},
			sortedConvosOld() {
				// let convos = this.convos;
				// case 1-2-default
				// .slice(0, 30 * this.convoListHeight)
				// let convos = this.convos.slice(0, 30 * this.convoListHeight);
				// if (this.emails.length) {
				// 	for (let convo of convos) {
				// 		let findp = this.prospects.find(p => p.Number == convo.ClientNumber);						
				// 		if (findp) {
				// 			convo.prospId = findp.id;
				// 			let finde = this.emails.find(e => e.ProspectID == convo.prospId);
				// 			if (finde) {
				// 				convo.isMailExist = true;
				// 				convo.emailConvoID = finde.id;
				// 				if (convo.Unread == 0) {
				// 					convo.Unread = finde.Unread;
				// 				}
				// 				if (convo.DateUpdated < finde.DateUpdated) {
				// 					convo.EmailDateUpdated = finde.DateUpdated;
				// 					// convo.DateUpdated = finde.DateUpdated;
				// 				}
				// 			}
				// 		}
				// 	}
				// }
				// this.makeLoaderTrue();
				switch (this.sort) {
					case 0:
						return this.sortByRecent();
						// return this.recentConvos.slice(0, 30 * this.convoListHeight);
					case 1:
						// return convos.sort((a, b) => a.DateUpdated - b.DateUpdated).slice(0, 30 * this.convoListHeight);
						return this.oldestConvos;
					case 2:
						return [...this.unreadConvos].sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
						// return this.sortByUnread(convos)
					case 3:
						return [...this.sortedConversations].sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
						// return this.sortByDueTask();
					case 4:
						return this.sortByStarred();
					case 5:
						return [...this.scheduledConvos].sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
					case 6:
						return [...this.autopilotConvos].sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
					case 7:
						return [...this.needHumanFeedbackConvos].sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
					case 8:
						return [...this.erroredConvos].sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
					default:
						return this.sortByFolder();
				}
				
			},
			sortedConvos() {
				let convos;
				switch (this.sort) {
					case 0:
						convos = this.sortByRecent();
						break;
					case 1:
						convos = this.oldestConvos;
						break;
					case 2:
						convos = [...this.unreadConvos].sort((a, b) => b.DateUpdated - a.DateUpdated);
						break;
					case 3:
						convos = [...this.sortedConversations].sort((a, b) => b.DateUpdated - a.DateUpdated);
						break;
					case 5:
						convos = [...this.scheduledConvos].sort((a, b) => b.DateUpdated - a.DateUpdated);
						break;
					case 6:
						convos = [...this.autopilotConvos].sort((a, b) => b.DateUpdated - a.DateUpdated);
						break;
					case 7:
						convos = [...this.needHumanFeedbackConvos].sort((a, b) => b.DateUpdated - a.DateUpdated);
						break;
					case 8:
						convos = [...this.erroredConvos].sort((a, b) => b.DateUpdated - a.DateUpdated);
						break;
					default:
						convos = this.sortByFolder();
				}

				const seen = new Set();
				const uniqueConvos = convos.filter((convo) => {
					if (seen.has(convo.id)) return false;
					seen.add(convo.id);
					return true;
				});

				return uniqueConvos.slice(0, 30 * this.convoListHeight); // Return paginated, unique list
			},
			...mapState('globals', ['scrollTop', 'activeConvo', 'activeProsp', 'format','startCount','unreadCountTotal','autopilotCountTotal','scheduleCountTotal','dueTaskCountTotal','limit']),
			...mapState('firebase', ['prospects', 'convos', 'user','emails','calls','phones','extensionuuid','fcmToken','messages','searchProspects'])
			// ...mapState('firebase', ['prospects', 'convos', 'user'])
		},
		created(){
			this.sortedConversations = this.convos;
			this.fetchNextBatch();
			if (performance.memory.usedJSHeapSize > 1000000000) { // 1 GB
				//eslint-disable-next-line
				console.log("memory heap size");
				// this.$store.dispatch('firebase/clearBoundData');
				// this.$store.dispatch('globals/CLEAR_ALL');
			}
			this.getEmailsFromDB();
			this.oldConvos = JSON.parse(JSON.stringify(this.convos));
			if(this.extensionuuid != null && this.extensionuuid != 0){
			//eslint-disable-next-line
			console.log("extensionuuid", this.extensionuuid);
			//eslint-disable-next-line
			console.log("prospects", this.prospects);
			let findp = this.prospects.find(p => this.normalizePhoneNumber(p.Number) == this.extensionuuid);	
			if(findp){
			// let c = this.convos.find(convo => this.normalizePhoneNumber(convo.ClientNumber));
			// this.openConvo(c.id,findp.id);
			this.openSearch(findp);
			}else{
				this.isNewProsp=true;
				//eslint-disable-next-line
				console.log("Not find prospects");
				this.form.Number=this.extensionuuid;
				setTimeout(() => {	
					this.$bvModal.show('ProspectModal1');
				}, 500);
			}
			}
		},
		methods: {
			setActiveFilter(filterId) {
				this.activeFilter = filterId;
			},
			fetchConvoData(uid) {
				this.showLoader = true;
                //eslint-disable-next-line
                console.log('userAuth.uid:', uid);
                this.$store.dispatch('firebase/rebindConvosNew', {uid:uid, page:this.currentPage, limit:this.limit})
                .then(() => {
                    //eslint-disable-next-line
                    console.log('Data Successfully Fetched A');
					this.totalRows = this.$store.state.firebase.convosCount;
					this.showLoader = false;
                })
                .catch((err) => {
                    //eslint-disable-next-line
                    console.error('Error fetching conversation data:', err);
					this.showLoader = false;
                });
            },
			fetchNextBatch() {
				this.showLoader = true;
				// this.$store.dispatch('firebase/rebindConvosNew', this.user.Uid, this.currentPage, this.perPage)
				this.$store.dispatch('firebase/rebindConvosCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
				.then(() => {
					//eslint-disable-next-line
					console.log("Conversation count:", this.$store.state.firebase.convosCount);

					const totalRecords = this.$store.state.firebase.convosCount; // Total number of records
					
					const totalPages = Math.ceil(totalRecords / this.limit); // Calculate total pages
					//eslint-disable-next-line
					console.log(`Convo Page Total Pages: ${totalPages}`); // Output: 7

					this.totalRows = totalRecords;
					this.showLoader = false;

					// total counts of filters 
					// this.feedbackCount = this.$store.state.firebase.feedbackCount;
					// this.erroredCount = this.$store.state.firebase.erroredCount;
					// this.unreadCount = this.$store.state.firebase.unreadCount;
					// this.autoPilotCount = this.$store.state.firebase.autoPilotCount;
					// this.scheduledCount = this.$store.state.firebase.scheduledCount;
					// this.startedCount = this.$store.state.firebase.starredCount;

					const overdueProspects = this.prospects.filter(prospect => this.isOverDue(prospect));
					this.$store.commit('globals/SET', { var: 'dueTaskCountTotal', val: overdueProspects.length });
				})
			},
			onPageChange(newPage) {
				this.currentPage = newPage;

				const startIndex = (this.currentPage - 1) * this.limit;
				const endIndex = this.currentPage * this.limit;

				this.filteredConvos = this.allFilteredConvos.slice(startIndex, endIndex);

				if (this.isFolderFilterClicked) {
					this.sortByFolder(this.selectedFolder, this.currentPage, this.limit);
				}
				if (this.isPriorityFilterClicked) {
					this.sortByPriority(this.selectedPriority, this.currentPage, this.limit);
				}
				if (this.isStageFilterClicked) {
					this.sortByStage(this.selectedStage, this.currentPage, this.limit);
				}
				if (this.sort === 0) {
					this.fetchConvoData(this.user.Uid);
				}
				if (this.sort === 1) {
					this.sortByOldest(this.currentPage,this.limit);
				}
				if (this.sort === 3) {
					this.sortByDueTask(this.currentPage,this.limit);
				}
				if (this.sort === 4) {
					this.sortByStarred(this.currentPage,this.limit);
				}
				if (this.sort === 5) {
					this.sortByScheduled();
				}
				if (this.sort === 6) {
					this.sortByAutopilot();
				}
				if (this.sort === 7) {
					this.sortByFeedbackNeeded();
				}
				if (this.sort === 8) {
					return this.$store
					.dispatch("firebase/erroredConvos", {
						uid: this.user.Uid,
						page: newPage,
						limit: this.limit,
					})
					.then((res) => {
						// eslint-disable-next-line
						console.log("erroredConvos:", res);
						this.erroredConvos = res;
						// Return the result
						return res;
					})
					.catch((error) => {
						// eslint-disable-next-line
						console.error("Error fetching errored conversations:", error);

						// Return an empty array in case of an error
						return [];
					});
				} 

				if(!this.isFilterClick){
				// this.convoListHeight = 0;
				// this.$store.commit('globals/SET', { var: 'activeProsp', val: null });
				// this.$store.commit('globals/SET', { var: 'activeConvo', val: null });
				//eslint-disable-next-line
				console.log(`Fetching records for page ${newPage}`);
				
				this.showLoader = true;
				this.$store.dispatch('firebase/rebindConvosNew', {
					uid: this.user.Uid,
					page: newPage,
					limit: this.limit,
				})
				.then(() => {
					// Log the data for debugging
					//eslint-disable-next-line
					console.log("Fetched records for page:", newPage, this.$store.state.firebase.convos);
					this.showLoader = false;
				})
				.catch(err => {
					//eslint-disable-next-line
					console.error("Error fetching records for page:", newPage, err);
				});

				// this.currentPage = newPage;

				// Fetch data for the current page
				// const startIndex = (this.currentPage - 1) * this.limit;
				// const endIndex = this.currentPage * this.limit;

				// Call Firestore to fetch records for the current page (optional)
				this.fetchRecords(startIndex, endIndex);
			}
			// }
			},
			fetchRecords(startIndex, endIndex) {
				//eslint-disable-next-line
				console.log(`Fetching records from ${startIndex + 1} to ${endIndex}`);
				// Add logic to fetch records for the current page if required
			},
			// ALLOW ONLY LETTERS, DIGITS AND WHITE SPACE
			isCheckPostalCode(e) {
				var value =  e.target.value;
				if (!e.key.match(/[a-zA-Z0-9 ]/) || (e.key == ' ' && value[value.length-1] == ' ')) {
					e.preventDefault();  
				}
			},
			async createProspect() {
				if (!this.optIn) {
					alert("Prospect cannot be added unless express permission is given");
					return;
				}
				if (this.NoteValue) {
					let notesArray = [{
						'date': Date.now(),
						'description': this.NoteValue,
						'mediaURL': ''
					}];
					this.form.Notes = notesArray;
				} else {
					this.form.Notes = [];
				}

				this.form.Stages = [{Date:new Date().valueOf(), Stage:this.form.Status}];
				
				this.$bvModal.hide('ProspectModal1');
				this.showLoader = true;
				
				// if (this.form.Number) {
				// 	await getPhoneData({Number:this.form.Number})
				// 	// .then((res) => {this.showPhoneData(res)})
				// 	// .catch(err => this.showPhoneError(err));
				// }
				let formattedNum = this.form.Number;
				this.form.Number = this.$parseNumber(this.form.Number);
				this.form.Source = 'Manual Entry';

				var endSpace = /\s+$/;
				if(this.form.First != '' && this.form.First !== 'undefined') {
                    if(endSpace.test(this.form.First)){
                        this.form.First = (this.form.First).replace(/\s+$/,''); 
                    }
                } 
				if(this.form.Last != '' && this.form.Last !== 'undefined') {
                    if(endSpace.test(this.form.Last)){
                        this.form.Last = (this.form.Last).replace(/\s+$/,''); 
                    }
                }
				if(this.form.Email != '' && this.form.Email !== 'undefined') {
                    if(endSpace.test(this.form.Email)){
                        this.form.Email = (this.form.Email).replace(/\s+$/,''); 
                    }
                }
				if(this.form.Zip != '' && this.form.Zip !== 'undefined') {
                    if(endSpace.test(this.form.Zip)){
                        this.form.Zip = (this.form.Zip).replace(/\s+$/,''); 
                    }
                }
				//eslint-disable-next-line
				console.log("form data",this.form);

				Promise.all([
					db.collection(`Users/${this.user.id}/Prospects`).add({
						...this.form,
						DateCreated: Date.now()
					}),
				])
				.then(values => {
					this.form = {};
					this.form.Status = "New";
					this.optIn = false;
					// this.$bvModal.hide('ProspectModal');
					let prosp = this.prospects.find(prosp => values[0].id == prosp.id);
					if (prosp) {
						setTimeout(() => {
							this.showLoader = false;
							this.emitProsp(prosp);
						}, 3000);
					}
					this.NoteValue = '';
				})
				.catch(err => {
					this.form.Number = formattedNum;
					this.$emit('error', err);
				})
			},
			normalizePhoneNumber(phoneNumber) {
			// Remove all non-digit characters from the phone number
			const normalizedNumber = phoneNumber.replace(/\D/g, "");
			if (normalizedNumber.startsWith('1')) {
				return normalizedNumber.substring(1);
			}
			return normalizedNumber;
			},
			emitProsp(prosp) {
				this.search = '';
				let findConvo;
				if(this.convos != null) {
					findConvo = this.convos.find(convo => convo.ClientNumber == prosp.Number);
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: findConvo.id });
				this.$store.dispatch('firebase/bindMessages', findConvo.id);
				if (this.emails && this.emails.length) {
					let mid = this.getEmailConvoID(prosp.id);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
					// this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(prosp.id));
				}
				// if (this.$route.path != '/chrome/Conversations') {
				// 	this.$router.push('/chrome/Conversations');
				// }
				this.$emit('open', 'prosp');
			},
			getAutoConvoData(data){
               this.autoConvoDetail = data;
			},
			async getEmailsFromDB(){
				if(this.extensionuuid != null && this.extensionuuid != 0){
					return;
				}
				this.$bvToast.toast('Email synchronization in progress...', {
					title: `Success`,
					variant: 'success',
					solid: true
				});
				setTimeout(() => {	
					this.$store.dispatch('firebase/rebindEmails', this.user.Uid);
				},7000);
			},
			makeLoaderTrue() {
				this.showLoader = true;
			},
			OnScroll() {
				let component = this.$refs.convoList;
				if (component.scrollTop + component.offsetHeight > component.scrollHeight - 1) {
					this.convoListHeight++;
					if (this.sort == 4 || this.sort > 8) {
						this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.convoListHeight);
					}
				}
			},
			async sortByFolder(i, page, pageSize) {
				this.isFolderFilterClicked = true;
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.convoListHeight = 1;
				this.sort = 8 + i;
				let iFolder = this.sort - 9;
				let convo = [];
				this.selectedFolder = i;
				
				if (iFolder >= 0) {
					let val1 = this.user.Folders[iFolder];
					if (val1) {
						// Set up the query for prospects based on Folder
						let prospectsQuery = db.collection(`Users/${this.user.id}/Prospects`)
							.where('Tags', 'array-contains', val1);

						const countSnapshot = await prospectsQuery.get();
						this.totalRows = countSnapshot.size;

						// eslint-disable-next-line
						console.log(this.totalRows);

						let query = prospectsQuery.limit(pageSize);

						if (page > 1) {
							const offset = (page - 1) * pageSize;

							// Fetch the last document of the previous page
							const snapshot = await prospectsQuery.limit(offset).get();

							if (!snapshot.empty) {
								const lastDoc = snapshot.docs[snapshot.docs.length - 1];
								query = prospectsQuery.startAfter(lastDoc).limit(pageSize);
							} else {
								throw new Error("No data found for the requested page in Prospects.");
							}
						}

						const prospectSnapshot = await query.get();

						// Collect Prospect Numbers
						const prospectNumbers = prospectSnapshot.docs.map((doc) => doc.data().Number).filter((number) => number !== undefined);

						if (prospectNumbers.length > 0) {
							// Batching logic for 'in' filter limitation (maximum 10 values per query)
							const batchSize = 10;
							for (let i = 0; i < prospectNumbers.length; i += batchSize) {
								const batch = prospectNumbers.slice(i, i + batchSize);

								let conversationsRef = db.collection('Conversations')
									.where('Uid', '==', this.user.Uid)
									.where('ClientNumber', 'in', batch)
									.where('autoSms', '==', true)
									.orderBy('autoSms', 'desc')
									.orderBy('DateUpdated', 'desc');

								const convoSnapshot = await conversationsRef.get();
								convoSnapshot.docs.forEach((doc) => {
									let data = { id: doc.id, ...doc.data() };
									convo.push(data);
								});
							}
						}
					}
				}

				// eslint-disable-next-line
				console.log('convo', convo);

				this.$store.commit("firebase/SET", {
					var: "convos",
					val: convo,
				});

				// Update filtered conversations with sorted and paginated results
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos
					.sort((a, b) => b.DateUpdated - a.DateUpdated)
					.slice(0, 30 * this.convoListHeight);

				this.showLoader = false;
			},
			async sortByStageOld(i) {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.convoListHeight =  1;
				this.sort = 8 + this.user.Folders.length + i;
				let numFolders = this.user.Folders ? this.user.Folders.length : 0;
				let iStage = this.sort - numFolders - 9;
				let convo = [];
				if (iStage >= 0) {
					let val = this.user.Stages[iStage];
					if (val) {
						let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Status', '==', val).get();
						colRef.docs.map((doc) => {
							let data = { id: doc.id, ...doc.data() };
							let c = this.convos.find(convo => convo.ClientNumber && convo.ClientNumber == data.Number);
							if (c) {
								convo.push(c)
							}
							return data;
						});
					}
				}
				this.allFilteredConvos = convo;
				//eslint-disable-next-line
				console.log(this.allFilteredConvos);
				
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
				this.showLoader = false;
			},
			async sortByStage(i, page, pageSize) {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.convoListHeight = 1;
				this.sort = 8 + this.user.Folders.length + i;
				let numFolders = this.user.Folders ? this.user.Folders.length : 0;
				let iStage = this.sort - numFolders - 9;
				let convo = [];
				this.isStageFilterClicked = true;
				this.selectedStage = i;
				
				if (iStage >= 0) {
					let val = this.user.Stages[iStage];
					if (val) {
						let prospectsQuery = db.collection(`Users/${this.user.id}/Prospects`)
							.where('Status', '==', val);

						const countSnapshot = await prospectsQuery.get();
						this.totalRows = countSnapshot.size;
						let query = prospectsQuery.limit(pageSize);

						if (page > 1) {
							const offset = (page - 1) * pageSize;

							// Fetch the last document of the previous page
							const snapshot = await prospectsQuery.limit(offset).get();

							if (!snapshot.empty) {
								const lastDoc = snapshot.docs[snapshot.docs.length - 1];
								query = prospectsQuery.startAfter(lastDoc).limit(pageSize);
							} else {
								throw new Error("No data found for the requested page in Prospects.");
							}
						}

						const prospectSnapshot = await query.get();

						// Collect Prospect Numbers
						const prospectNumbers = prospectSnapshot.docs.map((doc) => doc.data().Number).filter((number) => number !== undefined);

						if (prospectNumbers.length > 0) {
							// Batching logic for 'in' filter limitation (maximum 10 values per query)
							const batchSize = 10;
							for (let i = 0; i < prospectNumbers.length; i += batchSize) {
								const batch = prospectNumbers.slice(i, i + batchSize);
								// batch = batch.filter((number) => number !== undefined);
								let conversationsRef = db.collection('Conversations')
									.where('Uid', '==', this.user.Uid)
									.where('ClientNumber', 'in', batch)
									.orderBy('DateUpdated', 'desc');

								const convoSnapshot = await conversationsRef.get();
								convoSnapshot.docs.forEach((doc) => {
									let data = { id: doc.id, ...doc.data() };
									convo.push(data);
								});
							}
						}
					}
				}

				// eslint-disable-next-line
				console.log('convo', convo);

				this.$store.commit("firebase/SET", {
					var: "convos",
					val: convo,
				});

				// Update filtered conversations with sorted and paginated results
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos
					.sort((a, b) => b.DateUpdated - a.DateUpdated)
					.slice(0, 30 * this.convoListHeight);

				this.showLoader = false;
			},
			async sortByPriorityOld(p) {
				this.isPriorityClicked = true;
				this.sort =  5 + this.user.Folders.length + this.user.Stages.length + p;
				this.showLoader = true;
				this.convoListHeight =  1;
				let convo = [];
				let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('CciMap.Priority', '==', p).get();
				colRef.docs.map((doc) => {
					let data = { id: doc.id, ...doc.data() };
					let c = this.convos.find(convo => convo.ClientNumber == data.Number);
					if (c) {
						convo.push(c)
					}
					return data;
				});
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},
			async sortByPriority(p, page, pageSize) {
				this.isPriorityClicked = true;
				this.sort = 5 + this.user.Folders.length + this.user.Stages.length + p;
				this.showLoader = true;
				this.convoListHeight = 1;
				let convo = [];
				this.selectedPriority = p;
				this.isPriorityFilterClicked = true;

				// Set up the query for prospects based on Priority
				let prospectsQuery = db.collection(`Users/${this.user.id}/Prospects`)
					.where('CciMap.Priority', '==', p);

				const countSnapshot = await prospectsQuery.get();
				this.totalRows = countSnapshot.size;

				// Apply pagination to the query
				let query = prospectsQuery.limit(pageSize);

				if (page > 1) {
					const offset = (page - 1) * pageSize;

					// Fetch the last document of the previous page
					const snapshot = await prospectsQuery.limit(offset).get();

					if (!snapshot.empty) {
						const lastDoc = snapshot.docs[snapshot.docs.length - 1];
						query = prospectsQuery.startAfter(lastDoc).limit(pageSize);
					} else {
						throw new Error("No data found for the requested page in Prospects.");
					}
				}

				const prospectSnapshot = await query.get();

				// Collect Prospect Numbers
				const prospectNumbers = prospectSnapshot.docs.map((doc) => doc.data().Number).filter((number) => number !== undefined);

				if (prospectNumbers.length > 0) {
					// Batching logic for 'in' filter limitation (maximum 10 values per query)
					const batchSize = 10;
					for (let i = 0; i < prospectNumbers.length; i += batchSize) {
						const batch = prospectNumbers.slice(i, i + batchSize);

						let conversationsRef = db.collection('Conversations')
							.where('Uid', '==', this.user.Uid)
							.where('ClientNumber', 'in', batch)
							.orderBy('DateUpdated', 'desc');

						const convoSnapshot = await conversationsRef.get();
						convoSnapshot.docs.forEach((doc) => {
							let data = { id: doc.id, ...doc.data() };
							convo.push(data);
						});
					}
				}

				// eslint-disable-next-line
				console.log('convo', convo);

				this.$store.commit("firebase/SET", {
					var: "convos",
					val: convo,
				});

				// Update filtered conversations with sorted and paginated results
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos
					.sort((a, b) => b.DateUpdated - a.DateUpdated)
					.slice(0, 30 * this.convoListHeight);

				this.showLoader = false;
			},
			sortByOldestOld() {
				// var cnv = [];
				// Object.assign(cnv,convos) ;
				// for (let c of cnv) {
				// 	if (c.hasOwnProperty('EmailDateUpdated')) {
				// 		c.DateUpdated =  c.EmailDateUpdated;
				// 	}
				// }
				// let convos = this.convos.slice(0, 30 * this.convoListHeight);
				// if (this.emails.length) {
				// 	convos = this.filterEmailConvo(convos)
				// }
				
				this.isPriorityClicked = false;
				this.showLoader = false;
				return this.convos.sort((a, b) => a.DateUpdated - b.DateUpdated).slice(0, 30 * this.convoListHeight).filter(cv => cv.ClientNumber != '');
			},
			sortByOldest(page,limit) {
				this.isFilterClick = true;
				this.showLoader = true;
				this.$store.dispatch('firebase/rebindOldestConvos', {
					uid: this.user.Uid,
					page: page,
					limit: limit,
				})
				.then(() => {
					//eslint-disable-next-line
					console.log("Fetched records for page for oldest:",this.currentPage, this.$store.state.firebase.convos);
					this.oldestConvos = this.$store.state.firebase.convos;
					this.oldestConvos = this.oldestConvos.sort((a, b) => a.DateUpdated - b.DateUpdated).slice(0, 30 * this.convoListHeight)
					this.showLoader = false;
				})
				.catch(err => {
					//eslint-disable-next-line
					console.error("Error fetching records for page:", page, err);
				});
				this.isPriorityClicked = false;
			},
			sortByRecent() {
				// var cnv = [];
				// Object.assign(cnv,convos) ;
				// for (let c of cnv) {
				// 	if (c.hasOwnProperty('EmailDateUpdated')) {
				// 		c.DateUpdated =  c.EmailDateUpdated;
				// 	}
				// }
				this.isPriorityClicked = false;
				let convos = this.convos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight).filter(cv => cv.ClientNumber != '');
				if (this.emails && this.emails.length) {
					convos = this.filterEmailConvo(convos)
				}
				return convos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
			},
			sortByRecentOnFilter(page,limit) {
				this.isFilterClick = true;
				this.showLoader = true;
				this.$store.dispatch('firebase/rebindConvosNew', {
					uid: this.user.Uid,
					page: page,
					limit: limit,
				})
				.then(() => {
					//eslint-disable-next-line
					console.log("Fetched records for page recent:", this.currentPage, this.$store.state.firebase.convos);
					this.recentConvos = this.$store.state.firebase.convos;
					this.totalRows = this.recentConvos.length;
					this.showLoader = false;
				})
				.catch(err => {
					//eslint-disable-next-line
					console.error("Error fetching records for page:", err);
				});
				return this.recentConvos;
				// this.isPriorityClicked = false;
				// let convos = this.convos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight).filter(cv => cv.ClientNumber != '');
				// if (this.emails && this.emails.length) {
				// 	convos = this.filterEmailConvo(convos)
				// }
				// return convos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
			},
			filterEmailConvo(convos) {
				for (let convo of convos) {
					let findp = this.prospects.find(p => p.Number == convo.ClientNumber);						
					if (findp) {
						convo.prospId = findp.id;
						let finde = this.emails.find(e => e.ProspectID == convo.prospId);
						if (finde) {
							convo.isMailExist = true;
							convo.emailConvoID = finde.id;
							if (convo.Unread == 0) {
								convo.Unread = finde.Unread;
							}
							if (convo.DateUpdated < finde.DateUpdated) {
								// convo.EmailDateUpdated = finde.DateUpdated;
								convo.DateUpdated = finde.DateUpdated;
							}
						}
					}
				}
				return convos
			},
			filterClick(sort) {
				this.sort = sort;
				this.convoListHeight=1;
				this.$refs.convoList.scrollTop = 0;
			},
			getCallDetails(value) {
				this.$emit('getCallDetails',value);
			},
			openConvo(convoId, prospId) {
				if(this.autoConvoDetail){
					this.$delete(this.autoConvoDetail.sending, this.autoConvoDetail.id);
					this.autoConvoDetail="";
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: prospId });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: convoId });
				this.$store.dispatch('firebase/bindMessages', convoId);
				if(this.emails != null){
				if (this.emails && this.emails.length) {
					let mid = this.getEmailConvoID(prospId);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
				// 	this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(prospId));
				}
				}
				if(this.calls != null && this.calls.length){
					let cid = this.getCallsConvoID(prospId);
					if (cid){
						this.$store.dispatch('firebase/bindPhones', cid);
					}else {
						this.$store.dispatch('firebase/clearonlyPhonesData');
				}
				}
				this.changePage('convo');
				if (this.prosp) {
					if (!Object.keys(this.prosp).includes('CarrierType')) {
						getPhoneData({Number:this.prosp.Number})
						.then(res => this.showPhoneData(res))
						.catch(err => this.showPhoneError(err));
					}
				}
				
			},
			getEmailConvoID(prospId) {
				let mailid = '';
				let mail = this.emails.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (mail) {
					mailid = mail.id;
				}
				return mailid;
			},
			getCallsConvoID(prospId) {
				let phoneid = '';
				let phone = this.calls.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (phone) {
					phoneid = phone.id;
				}
				return phoneid;
			},
			showPhoneData(res) {
				let phoneData = JSON.parse(res.data);
				db.doc(`Users/${this.user.id}/Prospects/${this.prosp.id}`).update({CarrierType:phoneData.carrier.type})
			},
			showPhoneError(err) {
				alert(`Not able to find prospect Number Type : `+ err)
				db.doc(`Users/${this.user.id}/Prospects/${this.prosp.id}`).update({CarrierType:null})
			},
			async deleteProsp() {
				if (confirm("You are about to permanently remove this prospect and all conversation and email data!\n\nAre you sure you want to proceed?")) {
					this.showLoader = true;
					db.doc(`Users/${this.user.id}/Prospects/${this.activeProsp}`).delete();
					if(this.activeConvo) {
						db.doc(`Conversations/${this.activeConvo}`).delete();
					}
					const cnvref = await db.collection('Emails').where('ProspectID', '==', this.activeProsp).get();
					cnvref.docs.forEach(doc => {
						doc.ref.delete();
					});
                    const cnvrefCall = await db.collection('Calls').where('ProspectID', '==', this.activeProsp).get();
					cnvrefCall.docs.forEach(doc => {
						doc.ref.delete();
					});

					this.changePage('list');
					this.fetchConvoData(this.user.Uid);
				}
			},
			async openSearch(prosp) {
				let convoSnap = await db.collection('Conversations')
					.where('ClientNumber', '==', prosp.Number)
					.where('Uid', '==', this.user.Uid)
					.orderBy('DateUpdated', 'desc')
					.get();
				let convoData = convoSnap.docs.map(doc => ({
									id: doc.id, 
									...doc.data(),
								}));
				// eslint-disable-next-line
				console.log('convoSnap', convoData);

				let newConvo = convoData[0];

				this.tempConvo = newConvo;
				// newConvo.DateUpdated = Math.floor(Date.now());
				
				// if (newConvo && !this.convos.some(convo => convo.id === newConvo.id)) {
				// 	var newN = [...this.convos,newConvo];
				// 	this.$store.commit('firebase/SET', { var: 'convos', val: [...newN] });
				// }

				this.search = '';
				let convo = newConvo;
				// eslint-disable-next-line
				console.log('convo', convo);
				// let convo = this.convos.find(convo => convo.ClientNumber == prosp.Number);

				// // eslint-disable-next-line
				// console.log('convo', convo);

				if (!convo) {
					// eslint-disable-next-line
					console.log('convo inside',prosp.Number,this.user.Twilio,this.user.Uid);
					convo = await db.collection('Conversations').add({
						ClientNumber: prosp.Number,
						AgentNumber: this.user.Twilio,
						Uid: this.user.Uid,
						LastMessage: '',
						DateUpdated: 0,
						Unread: 0
					});
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
				this.$store.dispatch('firebase/bindMessages', convo.id)
				if (this.emails != null && this.emails.length) {
					let mid = this.getEmailConvoID(prosp.id);	
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
					// this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(prosp.id));
				}
				if(this.calls != null && this.calls.length){
				let cid = this.getCallsConvoID(prosp.id);
				if (cid) {
						this.$store.dispatch('firebase/bindPhones', cid);
					}else {
						this.$store.dispatch('firebase/clearonlyPhonesData');
					}
				}
				this.changePage('convo');
			},
			changePage(target) {
				if (target == 'list' && this.format != 'big') {
					this.$store.commit('globals/CLEAR', 'activeProsp');
					this.$store.commit('globals/CLEAR', 'activeConvo');
				}
				if (this.page == 'list' || (this.page == 'convo' && this.format == 'big')) {
					this.$store.commit('globals/SET', { var: 'scrollTop', val: this.$refs.convoList.scrollTop });
				}
				this.page = target;
			},
			scroll() {
				this.$refs.convoList.onscroll = () => {
					let component = this.$refs.convoList;
					if (component.scrollTop + component.offsetHeight >= component.scrollHeight - 2) {
						this.convoListHeight++;
					}
				};
			},
			async sortByDueTaskOld() {
				this.showLoader = true;
				this.isFilterClick = true;
				const convoSnap = await db
					.collection('Conversations')
					.where('Uid', '==', this.user.Uid)
					.get();
				const convos = convoSnap.docs.map(doc => ({
					id: doc.id,
					...doc.data(),
				}));

				this.isPriorityClicked = false;
				let dueConvos = [];
				for (let convo of convos) {
					let findProps = this.prospects.find(props => props.Number && props.Number == convo.ClientNumber);
					if (this.isOverDue(findProps)) {
						dueConvos.push(convo)
					}
				}
				
				const totalRecords = dueConvos.length;

				// eslint-disable-next-line
				console.log('totalRecords', totalRecords);

				this.totalRows = totalRecords;
				this.sortedConversations = dueConvos;
				this.showLoader = false;
			},
			async sortByDueTask(page, limit) {
				this.showLoader = true;
				this.isFilterClick = true;
				let convo = [];

				try {
					// Step 1: Filter overdue prospects
					const overdueProspects = this.prospects.filter(prospect => this.isOverDue(prospect));

					// eslint-disable-next-line
					console.log("Overdue Prospects:", overdueProspects);

					// Save the total rows for pagination UI
					this.totalRows = overdueProspects.length;

					const prospectNumbers = overdueProspects.map((doc) => doc.Number).filter((number) => number !== undefined);

					if (prospectNumbers.length > 0) {
						// Step 2: Batching logic for 'in' filter limitation (maximum 10 values per query)
						const batchSize = 10;
						const startingBatchIndex = Math.floor((page - 1) * limit / batchSize); // Which batch to start from
						const startingOffset = (page - 1) * limit % batchSize; // Offset within the batch
						let totalFetched = 0;

						for (let i = startingBatchIndex * batchSize; i < prospectNumbers.length; i += batchSize) {
							const batch = prospectNumbers.slice(i, i + batchSize);

							let conversationsRef = db.collection('Conversations')
								.where('Uid', '==', this.user.Uid)
								.where('ClientNumber', 'in', batch)
								.orderBy('DateUpdated', 'desc');

							// Apply pagination within the current batch
							let query = conversationsRef;

							if (i === startingBatchIndex * batchSize && startingOffset > 0) {
								// Skip the first `startingOffset` conversations in the starting batch
								const snapshot = await conversationsRef.limit(startingOffset).get();
								if (!snapshot.empty) {
									const lastDoc = snapshot.docs[snapshot.docs.length - 1];
									query = conversationsRef.startAfter(lastDoc).limit(limit - totalFetched);
								}
							} else {
								query = conversationsRef.limit(limit - totalFetched);
							}

							// Fetch the paginated results
							const convoSnapshot = await query.get();

							convoSnapshot.docs.forEach((doc) => {
								if (totalFetched < limit) { // Stop fetching once we hit the limit
									let data = { id: doc.id, ...doc.data() };
									convo.push(data);
									totalFetched++;
								}
							});

							// Break early if we've fetched enough data
							if (totalFetched >= limit) break;
						}
					}

					// eslint-disable-next-line
					console.log("Conversations:", convo);

					// Step 3: Commit results to Vuex store
					this.$store.commit("firebase/SET", {
						var: "convos",
						val: convo,
					});

					// Update filtered conversations
					this.sortedConversations = convo;

				} catch (error) {
					// eslint-disable-next-line
					console.error("Error fetching due task conversations with pagination:", error);
				} finally {
					this.showLoader = false;
				}
			},
			async sortByStarredOld1() {
				this.isPriorityClicked = false;
				this.isFilterClick = true;
				this.sort = 4;
				this.showLoader = true;
				this.convoListHeight =  1;
				let convo = [];
				let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Starred', '==', true).get();
				const convoPromises = colRef.docs.map(async (doc) => {
				let data = { id: doc.id, ...doc.data() };
				const convoSnap = await db
					.collection('Conversations')
					.where('Uid', '==', this.user.Uid)
					.where('ClientNumber', '==', data.Number)
					.get();

				// Extract data from convoSnap and push to the convo array
					return convoSnap.docs.map(doc => ({
						id: doc.id,
						...doc.data(),
					}));
				});
				const resolvedConvos = await Promise.all(convoPromises);

				// eslint-disable-next-line
				console.log('resolvedConvos', resolvedConvos);

				convo = resolvedConvos.flat();
				convo && convo.length ? this.totalRows = convo.length : 0;
				
				this.allFilteredConvos = convo;
				const startIndex = (this.currentPage - 1) * this.limit;
				const endIndex = this.currentPage * this.limit;
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(startIndex, endIndex).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},
			async sortByStarredOld() {
				this.isPriorityClicked = false;
				this.sort = 4;
				this.showLoader = true;
				this.convoListHeight =  1;
				let convo = [];
				let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Starred', '==', true).get();
				colRef.docs.map((doc) => {
					let data = { id: doc.id, ...doc.data() };
					let c = this.convos.find(convo => convo.ClientNumber && convo.ClientNumber == data.Number);
					if (c) {
						convo.push(c)
					}
					return data;
				});
				
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},
			async sortByStarred1(page, pageSize) {
				this.isPriorityClicked = false;
				this.isFilterClick = true;
				this.sort = 4;
				this.showLoader = true;
				this.convoListHeight = 1;
				let convo = [];

				try {
					// Set up the query for starred prospects
					let prospectsQuery = db.collection(`Users/${this.user.id}/Prospects`)
						.where('Starred', '==', true);

					// Get the total number of rows for starred prospects
					const countSnapshot = await prospectsQuery.get();
					this.totalRows = countSnapshot.size;

					// Apply pagination to the query
					let query = prospectsQuery.limit(pageSize);

					if (page > 1) {
						const offset = (page - 1) * pageSize;

						// Fetch the last document of the previous page
						const snapshot = await prospectsQuery.limit(offset).get();

						if (!snapshot.empty) {
							const lastDoc = snapshot.docs[snapshot.docs.length - 1];
							query = prospectsQuery.startAfter(lastDoc).limit(pageSize);
						} else {
							throw new Error("No data found for the requested page in Starred.");
						}
					}

					// Fetch paginated prospects
					const prospectSnapshot = await query.get();

					// Collect Prospect Numbers
					const prospectNumbers = prospectSnapshot.docs.map((doc) => doc.data().Number).filter((number) => number !== undefined);

					if (prospectNumbers.length > 0) {
						// Batching logic for 'in' filter limitation (maximum 10 values per query)
						const batchSize = 10;
						for (let i = 0; i < prospectNumbers.length; i += batchSize) {
							const batch = prospectNumbers.slice(i, i + batchSize);

							let conversationsRef = db.collection('Conversations')
								.where('Uid', '==', this.user.Uid)
								.where('ClientNumber', 'in', batch)
								.orderBy('DateUpdated', 'desc');

							const convoSnapshot = await conversationsRef.get();
							convoSnapshot.docs.forEach((doc) => {
								let data = { id: doc.id, ...doc.data() };
								convo.push(data);
							});
						}
					}

					// eslint-disable-next-line
					console.log('Starred conversations:', convo);

					// Update Vuex store
					this.$store.commit("firebase/SET", {
						var: "convos",
						val: convo,
					});

					// Update filtered conversations with sorted and paginated results
					this.allFilteredConvos = convo;
					this.filteredConvos = this.allFilteredConvos
						.sort((a, b) => b.DateUpdated - a.DateUpdated)
						.slice(0, 30 * this.convoListHeight);

					this.showLoader = false;
				} catch (error) {
					// eslint-disable-next-line
					console.error("Error fetching starred conversations with pagination:", error);
					this.showLoader = false;
				}
			},
			async sortByStarred(page, pageSize) {
				this.isPriorityClicked = false;
				this.isFilterClick = true;
				this.sort = 4;
				this.showLoader = true;
				this.convoListHeight = 1;
				let convo = [];

				try {
					// Step 1: Fetch all starred prospects
					const prospectsSnapshot = await db
						.collection(`Users/${this.user.id}/Prospects`)
						.where('Starred', '==', true)
						.get();

					this.totalRows = prospectsSnapshot.size;

					// Collect all Prospect Numbers
					const prospectNumbers = prospectsSnapshot.docs.map(doc => doc.data().Number).filter((number) => number !== undefined);

					if (prospectNumbers.length > 0) {
						// Step 2: Apply batching logic for Firestore `in` filter (max 10 values per query)
						const batchSize = 10;
						const allConversations = []; 
						const batchedPromises = [];

						for (let i = 0; i < prospectNumbers.length; i += batchSize) {
							const batch = prospectNumbers.slice(i, i + batchSize);

							let conversationsRef = db
								.collection('Conversations')
								.where('Uid', '==', this.user.Uid)
								.where('ClientNumber', 'in', batch)
								.orderBy('DateUpdated', 'desc');

							batchedPromises.push(conversationsRef.get());
						}

						// Step 3: Await all batched queries
						const convoSnapshots = await Promise.all(batchedPromises);

						convoSnapshots.forEach(snapshot => {
							snapshot.docs.forEach(doc => {
								const data = { id: doc.id, ...doc.data() };
								allConversations.push(data);
							});
						});

						// Step 4: Sort all conversations by `DateUpdated` and paginate
						convo = allConversations.sort((a, b) => b.DateUpdated - a.DateUpdated).slice((page - 1) * pageSize, page * pageSize);
					}

					// eslint-disable-next-line
					console.log('Starred conversations:', convo);

					// Step 5: Update Vuex store
					this.$store.commit("firebase/SET", {
						var: "convos",
						val: convo,
					})

					// Step 6: Update filtered conversations
					this.allFilteredConvos = convo;
					this.filteredConvos = convo;

					this.showLoader = false;
				} catch (error) {
					// eslint-disable-next-line
					console.error("Error fetching starred conversations with pagination:", error);
					this.showLoader = false;
				}
			},
			sortByScheduledOld (convos) {
				this.isPriorityClicked = false;
				let scheduledConvos = [];
				for (let convo of convos) {
					if (convo.hasOwnProperty('ScheduledCount') && convo.ScheduledCount && convo.ClientNumber) {
						scheduledConvos.push(convo);
						this.scheduledConvo.push(convo);
					}
				}
				return scheduledConvos
			},
			async sortByScheduledOld1(page, pageSize) {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.convoListHeight = 1;
				let scheduledConvos = [];

				try {
					// Set up the query for scheduled conversations
					let conversationsQuery = db.collection('Conversations')
						.where('Uid', '==', this.user.Uid)
						.where('ScheduledCount', '>', 0) // Assuming ScheduledCount > 0 indicates a scheduled conversation
						.orderBy('ScheduledCount', 'desc') // Sort by ScheduledCount if needed
						.orderBy('DateUpdated', 'desc'); // Sort by most recently updated conversations

					// Apply pagination to the query
					if (page > 1) {
						const offset = (page - 1) * pageSize;

						// Fetch the last document of the previous page
						const snapshot = await conversationsQuery.limit(offset).get();

						if (!snapshot.empty) {
							const lastDoc = snapshot.docs[snapshot.docs.length - 1];
							conversationsQuery = conversationsQuery.startAfter(lastDoc).limit(pageSize);
						} else {
							throw new Error("No data found for the requested page in Scheduled.");
						}
					} else {
						conversationsQuery = conversationsQuery.limit(pageSize);
					}

					// Fetch paginated scheduled conversations
					const convoSnapshot = await conversationsQuery.get();

					// Collect conversation data
					convoSnapshot.docs.forEach((doc) => {
						let data = { id: doc.id, ...doc.data() };
						scheduledConvos.push(data);
					});

					// eslint-disable-next-line
					console.log('Scheduled conversations:', scheduledConvos);

					// Update Vuex store
					this.$store.commit("firebase/SET", {
						var: "convos",
						val: scheduledConvos,
					});

					// Update filtered conversations with sorted and paginated results
					this.allFilteredConvos = scheduledConvos;
					this.filteredConvos = this.allFilteredConvos
						.sort((a, b) => b.DateUpdated - a.DateUpdated)
						.slice(0, pageSize * this.convoListHeight);

					this.showLoader = false;
				} catch (error) {
					// eslint-disable-next-line
					console.error("Error fetching scheduled conversations with pagination:", error);
					this.showLoader = false;
				}
			},

			async sortByScheduled() {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.isFilterClick = true;
				this.totalRows = this.$store.state.firebase.scheduledCount;
				return this.$store
					.dispatch("firebase/scheduledConvos", {
						uid: this.user.Uid,
						page: this.currentPage,
						limit: this.limit,
					})
					.then((res) => {
						// eslint-disable-next-line
						console.log("scheduledConvos:", res);
						this.scheduledConvos = res;
						this.showLoader = false;
						return res;
					})
					.catch((error) => {
						// eslint-disable-next-line
						console.error("Error fetching scheduledConvos conversations:", error);
						return [];
					});
			},
			sortByScheduled1(convos) {
				return convos.filter(convo => convo.ScheduledCount && convo.ClientNumber);
			},
			sortByAutopilot1 () {
				this.isPriorityClicked = false;
				this.showLoader = true;
				let convoSnap =db.collection('Conversations')
					.where('autoSms', '==', true)
					.where('Uid', '==', this.user.Uid)
					.get();
					let convoData = convoSnap.docs.map(doc => ({
						id: doc.id, 
						...doc.data(),
					}));
				
				// eslint-disable-next-line
				console.log("convoData:", convoData);
				this.showLoader = false;
				return convoData;
				// this.isPriorityClicked = false;
				// let autopilotConvos = [];
				// for (let convo of convos) {
				// 	if (convo.hasOwnProperty('autoSms') && convo.autoSms && convo.ClientNumber) {
				// 		autopilotConvos.push(convo)
				// 	}
				// }
				// return autopilotConvos
			},
			sortByUnreadOld() {
				this.isPriorityClicked = false;
				db.collection('Conversations')
					.where('Uid', '==', this.user.Uid)
					.get()
					.then(convoSnap => {
						let convoData = convoSnap.docs
							.map(doc => ({
								id: doc.id,
								...doc.data(),
							}))
							.filter(convo => convo.Unread > 0);
						this.sortedConversations = convoData;
						// eslint-disable-next-line
						console.log("Filtered Unread Conversations:", convoData);
					})
					.catch(error => {
						// eslint-disable-next-line
						console.error("Error fetching conversations:", error);
				});
			},
			sortByUnread() {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.isFilterClick = true;
				this.totalRows = this.$store.state.firebase.unreadCount;
				return this.$store
					.dispatch("firebase/unreadConvos", {
						uid: this.user.Uid,
						page: this.currentPage,
						limit: this.limit,
					})
					.then((res) => {
						// eslint-disable-next-line
						console.log("unreadConvos:", res);
						this.unreadConvos = res;
						this.showLoader = false;
						return res;
					})
					.catch((error) => {
						// eslint-disable-next-line
						console.error("Error fetching errored conversations:", error);
						return [];
					});
			},
			sortByAutopilot() {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.isFilterClick = true;
				this.totalRows = this.$store.state.firebase.autoPilotCount;
				return this.$store
					.dispatch("firebase/autopilotConvos", {
						uid: this.user.Uid,
						page: this.currentPage,
						limit: this.limit,
					})
					.then((res) => {
						// eslint-disable-next-line
						console.log("autopilotConvos:", res);
						this.autopilotConvos = res;
						this.showLoader = false;
						return res;
					})
					.catch((error) => {
						// eslint-disable-next-line
						console.error("Error fetching autopilotConvos conversations:", error);
						return [];
					});
			},
			async sortByFeedbackNeededOld () {			
				let convoSnap = await db.collection('Conversations')
					.where('needHumanFeedback', '==', true)
					.where('Uid', '==', this.user.Uid)
					.get();
					let convoData = convoSnap.docs.map(doc => ({
						id: doc.id, 
						...doc.data(),
					}));

				// eslint-disable-next-line
				console.log("convoData:", convoData);
				// var newN = [...this.convos,convoData[0]];
				return convoData[0];
				// this.isPriorityClicked = false;
				// let feedbackneededConvos = [];
				// for (let convo of convos) {
				// 	if (convo.hasOwnProperty('needHumanFeedback') && convo.needHumanFeedback && convo.ClientNumber) {
				// 		feedbackneededConvos.push(convo)
				// 	}
				// }
				// return feedbackneededConvos
			},
			async sortByFeedbackNeeded () {			
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.isFilterClick = true;
				this.totalRows = this.$store.state.firebase.feedbackCount;
			
				return this.$store
					.dispatch("firebase/needHumanFeedbackConvos", {
						uid: this.user.Uid,
						page: this.currentPage,
						limit: this.limit,
					})
					.then((res) => {
						// eslint-disable-next-line
						console.log("needHumanFeedbackConvos:", res);
						this.needHumanFeedbackConvos = res;
						this.showLoader = false;
						return res;
					})
					.catch((error) => {
						// eslint-disable-next-line
						console.error("Error fetching errored conversations:", error);
						return [];
					});
			},
			sortByErrored() {
				this.showLoader = true;
				this.totalRows = this.$store.state.firebase.erroredCount; // Set total rows
				return this.$store
					.dispatch("firebase/erroredConvos", {
						uid: this.user.Uid,
						page: this.page,
						limit: this.limit,
					})
					.then((res) => {
						// eslint-disable-next-line
						console.log("erroredConvos res:", res);
						this.erroredConvos = res;
						this.showLoader = false;

						// Return the result
						return res;
					})
					.catch((error) => {
						// eslint-disable-next-line
						console.error("Error fetching errored conversations:", error);
						// Return an empty array in case of an error
						return [];
					});
			},
			isOverDue(findProps) {
				let val = false;
				if(findProps && findProps.Tasks) {
					for (let task of findProps.Tasks) {
						if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now() || this.isToday(new Date(task.DueOn)))) {
							val = true;
							break	
						}
					}
					
				}
				return val
			},
			isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},
			manageLoader() {
				this.showLoader = !this.showLoader;
			},
		},
		watch: {
			showList: {
				immediate: true,
				handler(showList) {
					if (showList) {
						this.$nextTick(() => {
							this.$refs.convoList.scrollTop = this.scrollTop;
						})
					}
				}
			},
			sort(newValue) {
				this.currentPage = 1;

				if (newValue === 0) {
					this.fetchConvoData(this.user.Uid);
				}
				if (newValue < 9) {
					this.isFolderFilterClicked = false;
					this.isPriorityClicked = false;
					this.isStageFilterClicked = false;
				}
				if (newValue === 1) {
					this.sortByOldest(this.currentPage, this.limit);
				}
				if (newValue === 2) {
					this.sortByUnread();
				}
				if (newValue === 3) {
					this.sortByDueTask(this.currentPage, this.limit);
				}
				if (newValue === 5) {
					this.sortByScheduled();
				}
				if (newValue === 6) {
					this.sortByAutopilot();
				}
				if (newValue === 7) {
					this.sortByFeedbackNeeded();
				}
				if (newValue === 8) {
					this.sortByErrored();
				}
			},
		},
		data() {
			return {
				tempConvo:null,
				needHumanFeedback:false,
				isNewProsp:false,
				optIn: false,
				NoteValue:'',
				form: {
					Status:"New"
				},
				autoConvoDetail: '',
				convoListHeight: 1,
				page: 'list',
				search: '',
				sort: 0,
				showLoader:false,
				filteredConvos:[],
				allFilteredConvos:[],
				isPriorityClicked:false,
				unreadCount: null,
                dueTaskCount: null,
                scheduledCount: null,
				startedCount:null,
				autoPilotCount:null,
				feedbackCount:null,
				erroredCount:null,
				oldConvos:[],
				scheduledConvo:[],
				currentPage: 1,
				totalRows: 0,
				sortedConversations:[],
				erroredConvos:[],
				oldestConvos:[],
				recentConvos:[],
				unreadConvos:[],
				autopilotConvos:[],
				needHumanFeedbackConvos:[],
				scheduledConvos:[],
				isFolderFilterClicked:false,
				isStageFilterClicked:false,
				isPriorityFilterClicked:false,
				isFilterClick:false,
				selectedFolder: 0,
				selectedStage: 0,
				selectedPriority: 0,
				activeFilter: 1,
			}
		},
		mounted() {
			this.scroll();
		},
	}
</script>

<style scoped>
	.click-background {
		background-color:#e1e1d7d6 !important;
	}
	.badge-container {
		display: flex;
		flex-wrap: wrap;
		gap: 0.3rem;
		justify-content: flex-start;
		margin-top: 7px;
	}
	.badge-item {
		/* width: calc(50% - 0.5rem); */
		text-align: center;
		padding: 6px;
		font-size: 10px;
		cursor: pointer;
	}

	.red-background {
		background-color: yellow !important;
	}
	#ProspectModal1___BV_modal_outer_{
		z-index: 99999 !important;
	}
	#ConvoList {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 1001;
	}
	#Prospect {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		/* z-index: 1001; */
	}
	.active {
		background-color: #E5E5E5;
	}
    .collapse-width-enter,
    .collapse-width-leave-to{
        max-width: 0;
    }
    .collapse-width-leave,
    .collapse-width-enter-to{
        max-width: 35em;
    }
    .collapse-width-enter-active,
    .collapse-width-leave-active{
        transition: all .5s ease;
    }
	.loader1 {
position: fixed;
z-index: 1010;
top: 50%;
margin: auto;
left: 50%;
z-index: 1111;
}

.loader1:before {
content: "";
display: block;
position: fixed;
top: 0;
left: 0;
width: 100%;
min-height: 100%;
background-color: rgba(0, 0, 0, 0.3);
z-index: 1111;
}

.lds-ripple {
display: inline-block;
top: 50%;
position: relative;
width: 64px;
height: 64px;
}

.lds-ripple div {
position: absolute;
top: 50%;
border: 4px solid #000000;
opacity: 1;
border-radius: 50%;
animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
animation-delay: -0.5s;
}

@keyframes lds-ripple {
0% {
top: 28px;
left: 28px;
width: 0;
height: 0;
opacity: 1;
}
100% {
top: -1px;
left: -1px;
width: 58px;
height: 58px;
opacity: 0;
}
}
</style>
<style>
.forIpadUIConvo .dropdown-menu.dropdown-menu-right.show{
	transform: translate3d(-115px, 10px, 0px)!important;
}
/*.LoadMoreConvoScroll{
	margin-bottom: 2px;
}*/
</style>
